import { render, staticRenderFns } from "./VisibilityOffIcon.vue?vue&type=template&id=fb4cfade"
import script from "./VisibilityOffIcon.vue?vue&type=script&lang=js"
export * from "./VisibilityOffIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports